import React, { FC, useCallback, useMemo } from 'react';
import cx from 'classnames';
import { useLocation, useNavigate } from 'react-router-dom';
import { tt } from '@i18n/tt';

import { ISideBarItem } from '../types';
import useStyles from '../styles';

interface IProps extends ISideBarItem {}

const SideBarItem: FC<IProps> = ({ icon, title, path }) => {
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const classes = useStyles();

  const handleRedirect = useCallback(
    (path: string) => {
      navigate(path);
    },
    [navigate],
  );

  const isSelected = useMemo(
    () => pathname.split('/').includes(path.replace('/', '')),
    [path, pathname],
  );

  return (
    <div
      className={cx(classes.sidebarItem, {
        [classes.sidebarItemActive]: isSelected,
      })}
      onClick={() => {
        handleRedirect(path);
      }}
    >
      {icon}
      {tt(title as 'sideBar.home')}
    </div>
  );
};

export default SideBarItem;
